import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';

import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';
import {ThesisDetailsRoutingModule} from './thesis-details-routing.module';

import {LanguageDropdownModule} from 'shared/language-dropdown/language-dropdown.module';
import {ThesisDetailsRepository} from './repositories/thesis-details.repository';
import {ThesisDetailsService} from './services/thesis-details.service';
import {ThesisDetailsComponent} from './thesis-details.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    ThesisDetailsRoutingModule,
    LanguageDropdownModule,
  ],
  declarations: [
    ThesisDetailsComponent,
  ],
  providers: [
    ThesisDetailsService,
    ThesisDetailsRepository,
  ],
})

export class ThesisDetailsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/thesis/thesis-details/thesis-details.module.ts